import LandingPage from '../landing/LandingPage';

function Journey() {
  return <LandingPage />;
}

export default Journey;